import { useEffect, useState } from "react";

export type WebTheme = "dark" | "light";
export const WEB_THEME_KEY = "xiaobenben.web.theme";

function readTheme(): WebTheme {
  try {
    return localStorage.getItem(WEB_THEME_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

/** Web-only preference; storage failures must never prevent switching skins. */
export function useWebTheme() {
  const [theme, setTheme] = useState<WebTheme>(readTheme);
  useEffect(() => {
    const sync = (event: StorageEvent) => {
      if (event.key === WEB_THEME_KEY || event.key === null)
        setTheme(readTheme());
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    try {
      localStorage.setItem(WEB_THEME_KEY, next);
    } catch {
      // Private browsing / full storage: keep the preference for this session.
    }
  };
  return { theme, toggleTheme };
}
